import { render, staticRenderFns } from "./AddressLookup.vue?vue&type=template&id=04d5b732&"
import script from "./AddressLookup.vue?vue&type=script&lang=js&"
export * from "./AddressLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports